export const GIT_COMMIT = '413ef1c097ee5538bc2ec95761742f2515e3cb2d'
